import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import '../style/LayerFilter.css';
import LocaleUtils from "qwc2/utils/LocaleUtils";
import MultiRangeSlider from "multi-range-slider-react";
import {setLayerFilters} from "../actions/layersext";
import Icon from "qwc2/components/Icon";

class LayerFilters extends React.Component {
    static propTypes = {
        filters: PropTypes.array,
        setLayerFilters: PropTypes.func
    }
    static defaultProps = {}

    constructor(props) {
        super(props);
        this.state = {
            open: ''
        };
    }

    hasFilterValue(variable, value) {
        const values = this.getCurrentFilterValues();
        if (values[variable]) {
            return (values[variable].indexOf(value) > -1);
        }
        return false;
    }

    getCurrentFilterValues() {
        const fv = {};
        const filters = this.props.filters;

        for (let i = 0; i < filters.length; i++) {
            const filter = filters[i];
            const variable = filter.variable;
            if (typeof filter.currentFilterValues !== 'undefined') {
                // copy, the values are modified by the callers and must not alias the redux state
                const current = filter.currentFilterValues;
                fv[variable] = Array.isArray(current) ? [...current] : (current !== null && typeof current === 'object' ? {...current} : current);
            }
        }

        return fv;
    }

    setCurrentFilterValues(values) {
        this.applyLayerFilters(values);
    }

    hasAnyFilterValue(variable) {
        const values = this.getCurrentFilterValues();
        if (values[variable]) {
            return true;
        }
        return false;
    }

    getFilterValue(variable) {
        const values = this.getCurrentFilterValues();
        if (values[variable]) {
            return values[variable];
        }
        return null;
    }

    setFilterValues(variable, value) {
        const values = this.getCurrentFilterValues();

        if (!values[variable]) {
            values[variable] = [];
        }
        const current = this.hasFilterValue(variable, value);
        if (current) {
            values[variable].splice(values[variable].indexOf(value), 1);
        } else {
            values[variable].push(value);
        }

        this.setCurrentFilterValues(values);
    }

    setBooleanFilterValue(variable, value) {
        const values = this.getCurrentFilterValues();
        if (value === '') {
            if (values[variable]) {
                delete values[variable];
            }
        } else {
            values[variable] = (value === 'true');
        }

        this.setCurrentFilterValues(values);
    }

    renderCheckboxFilterOption(filter, option) {
        return (
            <label key={option.value}>
                <input checked={this.hasFilterValue(filter.variable, option.value)}
                       onChange={ev => this.setFilterValues(filter.variable, option.value)} type="checkbox"/>
                <span>{option.label}</span>
            </label>
        );
    }

    setSliderFilterValue(variable, vObject) {
        const values = this.getCurrentFilterValues();
        if (vObject.min == vObject.minValue && vObject.max == vObject.maxValue) {
            if (values[variable]) {
                delete values[variable];
                this.setCurrentFilterValues(values);
            }
        } else {
            let changed = false;
            if (values[variable]) {
                if (values[variable].min != vObject.minValue || values[variable].max != vObject.maxValue) {
                    changed = true;
                }
            } else {
                changed = true;
            }
            if (changed) {
                values[variable] = {
                    min: vObject.minValue,
                    max: vObject.maxValue
                };
                this.setCurrentFilterValues(values);
            }
        }
        //this.applyLayerFilters();
    }

    renderSliderFilter(filter) {
        let minValue = filter.min;
        let maxValue = filter.max;
        const values = this.getCurrentFilterValues();
        if (values[filter.variable]) {
            minValue = values[filter.variable].min;
            maxValue = values[filter.variable].max;
        }
        const key = "slider-" + minValue + "-" + maxValue;

        return (
            <div className="layer-filter-input layer-filter-slider">
                <MultiRangeSlider
                    key={key}
                    ruler={false}
                    min={filter.min}
                    max={filter.max}
                    step={filter.step}
                    minValue={minValue}
                    maxValue={maxValue}
                    barInnerColor="#afb3b2"
                    barLeftColor="#afb3b2"
                    barRightColor="#afb3b2"
                    onChange={(e) => {
                        this.setSliderFilterValue(filter.variable, e);
                    }}
                />
            </div>
        );
    }

    applyLayerFilters(values) {
        // build new filter objects instead of modifying the ones from the redux state
        const filters = this.props.filters.map(entry => {
            const filter = {...entry};
            const variable = filter.variable;

            if (typeof (values[variable]) === 'undefined' || values[variable].length == 0) {
                delete filter.currentFilterValues;
            } else {
                filter.currentFilterValues = values[variable];
            }
            return filter;
        });

        this.props.setLayerFilters(filters);
    }

    resetLayerFilters() {
        this.setCurrentFilterValues({});
        //this.applyLayerFilters();
    }

    renderBooleanFilter(filter) {
        return (
            <div className="layer-filter-input layer-filter-boolean">
                <select
                    onChange={ev => this.setBooleanFilterValue(filter.variable, ev.target.value)}
                    value={this.getFilterValue(filter.variable) || ""}
                >
                    <option value="">-</option>
                    <option value={true}>{LocaleUtils.tr("basic.yes")}</option>
                    <option value={false}>{LocaleUtils.tr("basic.no")}</option>
                </select>
            </div>
        );
    }

    renderCheckboxFilter(filter) {
        return (
            <div className="layer-filter-input layer-filter-checkbox">
                {filter.options.map(o => this.renderCheckboxFilterOption(filter, o))}
            </div>
        );
    }

    renderFilter(filter) {
        let filterInput = null;
        let active = (<Icon icon="confirm" />);
        let icon = (<Icon icon="chevron-down" />);
        if (!this.hasAnyFilterValue(filter.variable)) {
            active = null;
        }
        if (this.state.open == filter.variable) {
            icon = (<Icon icon="chevron-up" />);
            switch (filter.type) {
                case 'checkbox':
                    filterInput = this.renderCheckboxFilter(filter);
                    break;
                case 'boolean':
                    filterInput = this.renderBooleanFilter(filter);
                    break;
                case 'slider':
                    filterInput = this.renderSliderFilter(filter);
                    break;
                default:
                    filterInput = 'Unknown filter type ' + filter.type;
                    break;
            }
        }

        return (
            <div key={filter.variable}>
                <a className="layer-filter-label" onClick={() => this.setState({open: filter.variable})} >
                    {active}
                    <span className="text">
                        {filter.label}
                    </span>
                    {icon}
                </a>
                {filterInput}
            </div>
        );
    }

    render() {
        return (
            <div className="layer-filters">
                {this.props.filters.map(f => this.renderFilter(f))}
                <div className="layer-filter-buttons">
                    <button onClick={() => this.resetLayerFilters()}
                            className="button">{LocaleUtils.tr("basic.reset")}</button>
                </div>
            </div>
        );
    }
}

const selector = (state) => ({
    filters: state.layers.filters
});

export default connect(selector, {
    setLayerFilters: setLayerFilters
})(LayerFilters);
